import React, { Component } from 'react';
import { Row, Col } from 'react-flexbox-grid';
import { Link } from 'react-router-dom';
import { GridList, GridTile } from 'material-ui/GridList';
import '../styles/GridList.css';
import './CategoriesList.css';

export default class CategoriesList extends Component {

  renderCategory = (item) => {
    const { projectId } = this.props;

    if (!item.category) {
      return <div key={`category-${item.category.id}`} />;
    }

    return (
      <Link to={`/dashboard/category/${projectId}/${item.category.id}`} key={`category-${item.category.id}`}>
        <GridTile>
          <div className="category-symbol">
            <span className="circle">
              <span className="text">
                {item.category.symbol}
              </span>
            </span>
          </div>
          <div className="category-title">
            {item.category.title}
          </div>
        </GridTile>
      </Link>
    );
  };

  render() {
    const { categories } = this.props;

    return (
      <Row start="xs" top="xs" className="categories-list grid-list-container">
        <Col xs={12}>
          <GridList className="grid-list" padding={10}>
            {Object.keys(categories).map((categoryId) => this.renderCategory(categories[categoryId]))}
          </GridList>
        </Col>
      </Row>
    );
  }

};